var _defs, _ellipse, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _circle, _circle2, _path52, _circle3, _circle4, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _rect, _rect2, _g, _rect3, _rect4, _g2, _rect5, _rect6, _g3, _rect7, _rect8, _g4, _rect9, _rect10, _g5, _rect11, _rect12, _g6, _rect13, _rect14, _g7, _rect15, _rect16, _g8, _rect17, _rect18, _g9, _rect19, _rect20, _g10, _rect21, _rect22, _g11, _rect23, _rect24, _g12, _rect25, _rect26, _g13, _rect27, _rect28, _g14, _rect29, _rect30, _g15, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _rect31, _rect32, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _circle5, _path95, _path96, _path97, _g16, _path98;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHermesApi(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "01de04e9-0eb8-4bc0-bdda-127678a3489e",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 936.89,
    height: 830,
    viewBox: "0 0 936.89 830",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "e969c1f8-c53e-49bb-af82-32734eaa9cfa",
    x1: 28.76,
    y1: 305.07,
    x2: 28.76,
    y2: 212.89,
    gradientTransform: "matrix(0, -1, -1, 0, 931.32, 376.98)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "gray",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ea046c4d-22ef-4a44-b404-ca1d35daf76d",
    x1: -12.78,
    y1: 348.28,
    x2: -12.78,
    y2: 256.1,
    gradientTransform: "matrix(-1, 0, 0, 1, 761.21, 12.96)",
    xlinkHref: "#e969c1f8-c53e-49bb-af82-32734eaa9cfa"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a2efda15-530d-45aa-b3cd-49d05531735a",
    x1: -251.56,
    y1: 214.87,
    x2: -251.56,
    y2: 122.69,
    gradientTransform: "matrix(0, -1, -1, 0, 851.27, -6.15)",
    xlinkHref: "#e969c1f8-c53e-49bb-af82-32734eaa9cfa"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "094cca5d-27c3-47fb-8920-3b7298d459bd",
    x1: -38.6,
    y1: 396.54,
    x2: -38.6,
    y2: 304.36,
    gradientTransform: "matrix(0, -1, -1, 0, 797.39, 358.05)",
    xlinkHref: "#e969c1f8-c53e-49bb-af82-32734eaa9cfa"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "140a85c5-dcaa-41a5-bbcf-36a604c1c882",
    x1: 5.1,
    y1: 303.89,
    x2: 5.1,
    y2: 211.71,
    gradientTransform: "matrix(0, -1, -1, 0, 673.96, 304.05)",
    xlinkHref: "#e969c1f8-c53e-49bb-af82-32734eaa9cfa"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e09d3dbe-6def-45ce-bc92-f1e4ec85f07d",
    x1: 8.02,
    y1: 379.51,
    x2: 8.02,
    y2: 287.33,
    gradientTransform: "matrix(-1, 0, 0, 1, 561.18, 2.45)",
    xlinkHref: "#e969c1f8-c53e-49bb-af82-32734eaa9cfa"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bcc8fcf0-1b1e-40bd-bc5b-91eb65ebeff2",
    x1: 222.55,
    y1: 344.87,
    x2: 222.55,
    y2: 252.69,
    gradientTransform: "matrix(-1, 0, 0, 1, 560.23, 65.2)",
    xlinkHref: "#e969c1f8-c53e-49bb-af82-32734eaa9cfa"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "7026b8b1-cea2-4061-af6f-029e76fb3e92",
    x1: -232.1,
    y1: 207.78,
    x2: -232.1,
    y2: 115.6,
    gradientTransform: "matrix(-1, 0, 0, 1, 695.8, -56.66)",
    xlinkHref: "#e969c1f8-c53e-49bb-af82-32734eaa9cfa"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "5f629113-c274-4419-b6ca-105eac5d4e52",
    x1: 81.08,
    y1: 150.19,
    x2: 81.08,
    y2: 86.04,
    gradientTransform: "matrix(-1, 0, 0, 1, 701.15, 59.18)",
    xlinkHref: "#e969c1f8-c53e-49bb-af82-32734eaa9cfa"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c2ef43ed-fda2-43ff-bd84-ecc107fb70b7",
    x1: 516.74,
    y1: 89.41,
    x2: 516.74,
    y2: 25.26,
    gradientTransform: "matrix(-1, 0, 0, 1, 708.54, 220.35)",
    xlinkHref: "#e969c1f8-c53e-49bb-af82-32734eaa9cfa"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "127fb363-6911-40f5-b8ae-4e9fbcd2cde8",
    x1: -103.84,
    y1: 299.15,
    x2: -103.84,
    y2: 235,
    gradientTransform: "matrix(-1, 0, 0, 1, 742.42, -17.51)",
    xlinkHref: "#e969c1f8-c53e-49bb-af82-32734eaa9cfa"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "30b9b037-13cf-442c-b7db-08ecd3a25147",
    x1: 5.85,
    y1: 100.35,
    x2: 5.85,
    y2: 36.2,
    gradientTransform: "matrix(-1, 0, 0, 1, 678.13, 35.41)",
    xlinkHref: "#e969c1f8-c53e-49bb-af82-32734eaa9cfa"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b48a5982-ebae-46b6-b7c0-ced25ac90cb4",
    x1: -301.21,
    y1: 237.7,
    x2: -301.21,
    y2: 173.55,
    gradientTransform: "matrix(-1, 0, 0, 1, 706.99, -84.53)",
    xlinkHref: "#e969c1f8-c53e-49bb-af82-32734eaa9cfa"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "3f302154-f399-4639-adea-16a823494a16",
    x1: 460.43,
    y1: -26.58,
    x2: 460.43,
    y2: -90.72,
    gradientTransform: "matrix(-1, 0, 0, 1, 662.94, 207.84)",
    xlinkHref: "#e969c1f8-c53e-49bb-af82-32734eaa9cfa"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "3ada4877-fd8b-49b1-a88c-9dc9f5ba336c",
    x1: -53.79,
    y1: 240.48,
    x2: -53.79,
    y2: 148.3,
    gradientTransform: "matrix(0, -1, -1, 0, 677.47, 190.28)",
    xlinkHref: "#e969c1f8-c53e-49bb-af82-32734eaa9cfa"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d51fede2-78e8-4620-b3d8-713c35bf1f26",
    x1: 417.01,
    y1: 548.49,
    x2: 417.01,
    y2: 166.82,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#e969c1f8-c53e-49bb-af82-32734eaa9cfa"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "1006e8ff-8602-4633-86d3-6de2a9ceacc2",
    x1: 2864.89,
    y1: 548.49,
    x2: 2864.89,
    y2: 166.82,
    gradientTransform: "matrix(-1, 0, 0, 1, 3576, 0)",
    xlinkHref: "#e969c1f8-c53e-49bb-af82-32734eaa9cfa"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fbbe768f-3ed7-4776-9e16-963371c4c4e8",
    x1: 540.33,
    y1: 551.53,
    x2: 540.33,
    y2: 551.26,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#e969c1f8-c53e-49bb-af82-32734eaa9cfa"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "34e30e13-4b6f-4fce-83d2-4daee813bb86",
    x1: 523.98,
    y1: 692.77,
    x2: 523.98,
    y2: 292.62,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#e969c1f8-c53e-49bb-af82-32734eaa9cfa"
  }))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "messenger") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 425.31,
    cy: 780.79,
    rx: 295.92,
    ry: 49.21,
    fill: "#6c63ff",
    opacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M371.3,791s-17.45-59.24,3.27-102.84a93.57,93.57,0,0,0,7.57-58.7,157.36,157.36,0,0,0-8.31-27.55",
    transform: "translate(-131.56 -35)",
    fill: "none",
    stroke: "#535461",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M386.72,574.37c0,7.26-13.15,28.31-13.15,28.31s-13.15-21.05-13.15-28.31a13.15,13.15,0,1,1,26.29,0Z",
    transform: "translate(-131.56 -35)",
    fill: "#6c63ff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M408.45,614.59C404.5,620.68,382,631.21,382,631.21s.41-24.82,4.35-30.91a13.15,13.15,0,0,1,22.07,14.29Z",
    transform: "translate(-131.56 -35)",
    fill: "#6c63ff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M407.5,683.31c-6.48,3.27-31.2,1-31.2,1s12.88-21.22,19.36-24.49a13.15,13.15,0,1,1,11.84,23.48Z",
    transform: "translate(-131.56 -35)",
    fill: "#6c63ff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M395.07,735.15c-5.84,4.32-30.58,6.27-30.58,6.27s9.11-23.09,14.95-27.41a13.15,13.15,0,1,1,15.63,21.14Z",
    transform: "translate(-131.56 -35)",
    fill: "#6c63ff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M354.42,632.62c5.21,5.06,29.47,10.3,29.47,10.3s-5.94-24.1-11.15-29.16a13.15,13.15,0,1,0-18.32,18.86Z",
    transform: "translate(-131.56 -35)",
    fill: "#6c63ff"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M340.66,693.42c6.48,3.27,31.2,1,31.2,1S359,673.22,352.5,669.95a13.15,13.15,0,1,0-11.84,23.48Z",
    transform: "translate(-131.56 -35)",
    fill: "#6c63ff"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M335.39,754.36c5.84,4.32,30.58,6.27,30.58,6.27s-9.11-23.09-14.95-27.41a13.15,13.15,0,1,0-15.63,21.14Z",
    transform: "translate(-131.56 -35)",
    fill: "#6c63ff"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M386.72,574.37c0,7.26-13.15,28.31-13.15,28.31s-13.15-21.05-13.15-28.31a13.15,13.15,0,1,1,26.29,0Z",
    transform: "translate(-131.56 -35)",
    fill: "#6c63ff",
    opacity: 0.1
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M408.45,614.59C404.5,620.68,382,631.21,382,631.21s.41-24.82,4.35-30.91a13.15,13.15,0,0,1,22.07,14.29Z",
    transform: "translate(-131.56 -35)",
    fill: "#6c63ff",
    opacity: 0.1
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M407.5,683.31c-6.48,3.27-31.2,1-31.2,1s12.88-21.22,19.36-24.49a13.15,13.15,0,1,1,11.84,23.48Z",
    transform: "translate(-131.56 -35)",
    fill: "#6c63ff",
    opacity: 0.1
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M395.07,735.15c-5.84,4.32-30.58,6.27-30.58,6.27s9.11-23.09,14.95-27.41a13.15,13.15,0,1,1,15.63,21.14Z",
    transform: "translate(-131.56 -35)",
    fill: "#6c63ff",
    opacity: 0.1
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M354.42,632.62c5.21,5.06,29.47,10.3,29.47,10.3s-5.94-24.1-11.15-29.16a13.15,13.15,0,1,0-18.32,18.86Z",
    transform: "translate(-131.56 -35)",
    fill: "#6c63ff",
    opacity: 0.1
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M340.66,693.42c6.48,3.27,31.2,1,31.2,1S359,673.22,352.5,669.95a13.15,13.15,0,1,0-11.84,23.48Z",
    transform: "translate(-131.56 -35)",
    fill: "#6c63ff",
    opacity: 0.1
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M335.39,754.36c5.84,4.32,30.58,6.27,30.58,6.27s-9.11-23.09-14.95-27.41a13.15,13.15,0,1,0-15.63,21.14Z",
    transform: "translate(-131.56 -35)",
    fill: "#6c63ff",
    opacity: 0.1
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M717.11,787.07s-17.45-59.24,3.27-102.84a93.57,93.57,0,0,0,7.57-58.7A157.36,157.36,0,0,0,719.64,598",
    transform: "translate(-131.56 -35)",
    fill: "none",
    stroke: "#535461",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M732.53,570.42c0,7.26-13.15,28.31-13.15,28.31s-13.15-21.05-13.15-28.31a13.15,13.15,0,0,1,26.29,0Z",
    transform: "translate(-131.56 -35)",
    fill: "#6c63ff"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M754.26,610.63c-3.95,6.09-26.42,16.62-26.42,16.62s.41-24.82,4.35-30.91a13.15,13.15,0,1,1,22.07,14.29Z",
    transform: "translate(-131.56 -35)",
    fill: "#6c63ff"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M753.31,679.36c-6.48,3.27-31.2,1-31.2,1s12.88-21.22,19.36-24.49a13.15,13.15,0,0,1,11.84,23.48Z",
    transform: "translate(-131.56 -35)",
    fill: "#6c63ff"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M740.88,731.19c-5.84,4.32-30.58,6.27-30.58,6.27s9.11-23.09,14.95-27.41a13.15,13.15,0,0,1,15.63,21.14Z",
    transform: "translate(-131.56 -35)",
    fill: "#6c63ff"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M700.23,628.66c5.21,5.06,29.47,10.3,29.47,10.3s-5.94-24.1-11.15-29.16a13.15,13.15,0,0,0-18.32,18.86Z",
    transform: "translate(-131.56 -35)",
    fill: "#6c63ff"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M686.47,689.47c6.48,3.27,31.2,1,31.2,1S704.79,669.26,698.31,666a13.15,13.15,0,0,0-11.84,23.48Z",
    transform: "translate(-131.56 -35)",
    fill: "#6c63ff"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M681.2,750.4c5.84,4.32,30.58,6.27,30.58,6.27s-9.11-23.09-14.95-27.41A13.15,13.15,0,0,0,681.2,750.4Z",
    transform: "translate(-131.56 -35)",
    fill: "#6c63ff"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M732.53,570.42c0,7.26-13.15,28.31-13.15,28.31s-13.15-21.05-13.15-28.31a13.15,13.15,0,0,1,26.29,0Z",
    transform: "translate(-131.56 -35)",
    fill: "#6c63ff",
    opacity: 0.1
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M754.26,610.63c-3.95,6.09-26.42,16.62-26.42,16.62s.41-24.82,4.35-30.91a13.15,13.15,0,1,1,22.07,14.29Z",
    transform: "translate(-131.56 -35)",
    fill: "#6c63ff",
    opacity: 0.1
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M753.31,679.36c-6.48,3.27-31.2,1-31.2,1s12.88-21.22,19.36-24.49a13.15,13.15,0,0,1,11.84,23.48Z",
    transform: "translate(-131.56 -35)",
    fill: "#6c63ff",
    opacity: 0.1
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M740.88,731.19c-5.84,4.32-30.58,6.27-30.58,6.27s9.11-23.09,14.95-27.41a13.15,13.15,0,0,1,15.63,21.14Z",
    transform: "translate(-131.56 -35)",
    fill: "#6c63ff",
    opacity: 0.1
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M700.23,628.66c5.21,5.06,29.47,10.3,29.47,10.3s-5.94-24.1-11.15-29.16a13.15,13.15,0,0,0-18.32,18.86Z",
    transform: "translate(-131.56 -35)",
    fill: "#6c63ff",
    opacity: 0.1
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M686.47,689.47c6.48,3.27,31.2,1,31.2,1S704.79,669.26,698.31,666a13.15,13.15,0,0,0-11.84,23.48Z",
    transform: "translate(-131.56 -35)",
    fill: "#6c63ff",
    opacity: 0.1
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M681.2,750.4c5.84,4.32,30.58,6.27,30.58,6.27s-9.11-23.09-14.95-27.41A13.15,13.15,0,0,0,681.2,750.4Z",
    transform: "translate(-131.56 -35)",
    fill: "#6c63ff",
    opacity: 0.1
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M245.11,669.95s21,41.15,3.88,63.67,1.55,83.86,1.55,83.86",
    transform: "translate(-131.56 -35)",
    fill: "none",
    stroke: "#6c63ff",
    strokeMiterlimit: 10
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M251.32,657.14c0,7.93-5.82,14.36-5.82,14.36s-5.82-6.43-5.82-14.36,5.82-14.36,5.82-14.36S251.32,649.2,251.32,657.14Z",
    transform: "translate(-131.56 -35)",
    fill: "#6c63ff"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M256,669.95s-21,41.15-3.88,63.67-1.55,83.86-1.55,83.86",
    transform: "translate(-131.56 -35)",
    fill: "none",
    stroke: "#6c63ff",
    strokeMiterlimit: 10
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M249.77,657.14c0,7.93,5.82,14.36,5.82,14.36s5.82-6.43,5.82-14.36-5.82-14.36-5.82-14.36S249.77,649.2,249.77,657.14Z",
    transform: "translate(-131.56 -35)",
    fill: "#6c63ff"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M249.77,657.14c0,7.93,5.82,14.36,5.82,14.36s5.82-6.43,5.82-14.36-5.82-14.36-5.82-14.36S249.77,649.2,249.77,657.14Z",
    transform: "translate(-131.56 -35)",
    opacity: 0.1
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M264.52,669.95s21,41.15,3.88,63.67S270,817.48,270,817.48",
    transform: "translate(-131.56 -35)",
    fill: "none",
    stroke: "#6c63ff",
    strokeMiterlimit: 10
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M270.73,657.14c0,7.93-5.82,14.36-5.82,14.36s-5.82-6.43-5.82-14.36,5.82-14.36,5.82-14.36S270.73,649.2,270.73,657.14Z",
    transform: "translate(-131.56 -35)",
    fill: "#6c63ff"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M267.47,690.11c-5.5,5.72-14.16,6.31-14.16,6.31s.26-8.67,5.76-14.39,14.16-6.31,14.16-6.31S273,684.39,267.47,690.11Z",
    transform: "translate(-131.56 -35)",
    fill: "#6c63ff"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M268,718.5c-5.5,5.72-14.16,6.31-14.16,6.31s.26-8.67,5.76-14.39,14.16-6.31,14.16-6.31S273.51,712.78,268,718.5Z",
    transform: "translate(-131.56 -35)",
    fill: "#6c63ff"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M238.19,734.12c5.2,6,5,14.66,5,14.66s-8.61-1-13.81-7-5-14.66-5-14.66S233,728.13,238.19,734.12Z",
    transform: "translate(-131.56 -35)",
    fill: "#6c63ff"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M243,673.57c6.61,4.38,8.76,12.79,8.76,12.79s-8.58,1.3-15.19-3.08-8.76-12.79-8.76-12.79S236.4,669.19,243,673.57Z",
    transform: "translate(-131.56 -35)",
    fill: "#6c63ff"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M243,673.57c6.61,4.38,8.76,12.79,8.76,12.79s-8.58,1.3-15.19-3.08-8.76-12.79-8.76-12.79S236.4,669.19,243,673.57Z",
    transform: "translate(-131.56 -35)",
    opacity: 0.1
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M275.39,669.95s-21,41.15-3.88,63.67S270,817.48,270,817.48",
    transform: "translate(-131.56 -35)",
    fill: "none",
    stroke: "#6c63ff",
    strokeMiterlimit: 10
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M269.18,657.14c0,7.93,5.82,14.36,5.82,14.36s5.82-6.43,5.82-14.36S275,642.77,275,642.77,269.18,649.2,269.18,657.14Z",
    transform: "translate(-131.56 -35)",
    fill: "#6c63ff"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M269.18,657.14c0,7.93,5.82,14.36,5.82,14.36s5.82-6.43,5.82-14.36S275,642.77,275,642.77,269.18,649.2,269.18,657.14Z",
    transform: "translate(-131.56 -35)",
    opacity: 0.1
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M270.85,690.72c-5.57,5.65-5.93,14.32-5.93,14.32s8.66-.49,14.23-6.14,5.93-14.32,5.93-14.32S276.42,685.07,270.85,690.72Z",
    transform: "translate(-131.56 -35)",
    fill: "#6c63ff"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M270.85,690.72c-5.57,5.65-5.93,14.32-5.93,14.32s8.66-.49,14.23-6.14,5.93-14.32,5.93-14.32S276.42,685.07,270.85,690.72Z",
    transform: "translate(-131.56 -35)",
    opacity: 0.1
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M281.77,730c-5.57,5.65-5.93,14.32-5.93,14.32s8.66-.49,14.23-6.14S296,723.88,296,723.88,287.34,724.38,281.77,730Z",
    transform: "translate(-131.56 -35)",
    fill: "#6c63ff"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M265.71,721.39S278.33,701.5,296,701.07",
    transform: "translate(-131.56 -35)",
    fill: "none",
    stroke: "#6c63ff",
    strokeMiterlimit: 10
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M255.88,709.38s-12.62-19.89-30.33-20.32",
    transform: "translate(-131.56 -35)",
    fill: "none",
    stroke: "#6c63ff",
    strokeMiterlimit: 10
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M254.24,737.77s12.62-19.89,30.33-20.32",
    transform: "translate(-131.56 -35)",
    fill: "none",
    stroke: "#6c63ff",
    strokeMiterlimit: 10
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 163.91,
    cy: 665.92,
    r: 3.28,
    fill: "#6c63ff"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 94.3,
    cy: 654.18,
    r: 3.28,
    fill: "#6c63ff"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M263.52,744.32S250.9,724.43,233.19,724",
    transform: "translate(-131.56 -35)",
    fill: "none",
    stroke: "#6c63ff",
    strokeMiterlimit: 10
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 101.94,
    cy: 689.12,
    r: 3.28,
    fill: "#6c63ff"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 153.26,
    cy: 682.57,
    r: 3.28,
    fill: "#6c63ff"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M333.28,793.58s-30.41-6.08-38.52-14.19-44.6-22.3-48.66-12.16-54.74,44.6-20.27,50.69,81.1,8.11,91.23,4.05S333.28,793.58,333.28,793.58Z",
    transform: "translate(-131.56 -35)",
    fill: "#a8a8a8"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M225.83,814.14c34.47,6.08,81.1,8.11,91.23,4.05,7.72-3.09,13.08-17.92,15.21-24.83l1,.21S327.2,817.91,317.06,822s-56.77,2-91.23-4.05c-9.95-1.76-12.79-5.88-11.72-11.1C215,810.22,218.42,812.84,225.83,814.14Z",
    transform: "translate(-131.56 -35)",
    opacity: 0.2
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M840.73,720.05s10,13.13-4.63,33-26.77,36.56-21.88,48.91c0,0,22.14-36.81,40.16-37.33S860.55,742.19,840.73,720.05Z",
    transform: "translate(-131.56 -35)",
    fill: "#6c63ff"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M840.73,720.05a16.26,16.26,0,0,1,2.05,4.12c17.58,20.66,26.95,39.94,10,40.42-15.74.45-34.63,28.6-39.15,35.71a15.26,15.26,0,0,0,.54,1.62s22.14-36.81,40.16-37.33S860.55,742.19,840.73,720.05Z",
    transform: "translate(-131.56 -35)",
    opacity: 0.1
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M859.39,736.79c0,4.62-.52,8.37-1.16,8.37s-1.16-3.75-1.16-8.37.65-2.45,1.29-2.45S859.39,732.17,859.39,736.79Z",
    transform: "translate(-131.56 -35)",
    fill: "#ffd037"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M865.8,742.31c-4.06,2.21-7.59,3.55-7.9,3s2.73-2.81,6.79-5,2.46-.6,2.76,0S869.85,740.09,865.8,742.31Z",
    transform: "translate(-131.56 -35)",
    fill: "#ffd037"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M787.7,720.05s-10,13.13,4.63,33,26.77,36.56,21.88,48.91c0,0-22.14-36.81-40.16-37.33S767.87,742.19,787.7,720.05Z",
    transform: "translate(-131.56 -35)",
    fill: "#6c63ff"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M787.7,720.05a16.26,16.26,0,0,0-2.05,4.12c-17.58,20.66-26.95,39.94-10,40.42,15.74.45,34.63,28.6,39.15,35.71a15.26,15.26,0,0,1-.54,1.62s-22.14-36.81-40.16-37.33S767.87,742.19,787.7,720.05Z",
    transform: "translate(-131.56 -35)",
    opacity: 0.1
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M769,736.79c0,4.62.52,8.37,1.16,8.37s1.16-3.75,1.16-8.37-.65-2.45-1.29-2.45S769,732.17,769,736.79Z",
    transform: "translate(-131.56 -35)",
    fill: "#ffd037"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M762.63,742.31c4.06,2.21,7.59,3.55,7.9,3s-2.73-2.81-6.79-5-2.46-.6-2.76,0S758.57,740.09,762.63,742.31Z",
    transform: "translate(-131.56 -35)",
    fill: "#ffd037"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M772.23,800.2s28.07-.86,36.53-6.89,43.18-13.22,45.28-3.56,42.19,48.05,10.49,48.31-73.64-4.94-82.08-10.08S772.23,800.2,772.23,800.2Z",
    transform: "translate(-131.56 -35)",
    fill: "#a8a8a8"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M865.1,834.7c-31.69.26-73.64-4.94-82.08-10.08-6.43-3.92-9-18-9.85-24.46l-.94,0S774,822.84,782.45,828s50.39,10.34,82.08,10.08c9.15-.07,12.31-3.33,12.13-8.15C875.4,832.83,871.91,834.65,865.1,834.7Z",
    transform: "translate(-131.56 -35)",
    opacity: 0.2
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 626.25,
    y: 273.22,
    width: 92.18,
    height: 149.99,
    transform: "translate(-11.75 830.91) rotate(-70.52)",
    fill: "url(#e969c1f8-c53e-49bb-af82-32734eaa9cfa)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 628.93,
    y: 274.79,
    width: 86.03,
    height: 144.91,
    transform: "translate(-11.1 829.89) rotate(-70.52)",
    fill: "#f4f6f7"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("rect", {
    x: 618.91,
    y: 293.48,
    width: 18.44,
    height: 13.64,
    transform: "translate(988.56 757.92) rotate(-160.52)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 621.27,
    y: 341.24,
    width: 70.79,
    height: 4.42,
    transform: "translate(1029.61 851.26) rotate(-160.52)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 636.45,
    y: 354.9,
    width: 51.62,
    height: 2.95,
    transform: "matrix(-0.94, -0.33, 0.33, -0.94, 1036.17, 878.25)",
    fill: "#6c63ff"
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 698.99,
    y: 269.06,
    width: 149.99,
    height: 92.18,
    transform: "translate(-193.13 265.25) rotate(-21.13)",
    fill: "url(#ea046c4d-22ef-4a44-b404-ca1d35daf76d)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 700.6,
    y: 271.66,
    width: 144.91,
    height: 86.03,
    transform: "translate(-193.02 264.88) rotate(-21.13)",
    fill: "#fff"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("rect", {
    x: 700.02,
    y: 300.75,
    width: 18.44,
    height: 13.64,
    transform: "translate(1350.1 303.74) rotate(158.87)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 723.59,
    y: 319.53,
    width: 70.79,
    height: 4.42,
    transform: "translate(1451.37 313.2) rotate(158.87)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 745.84,
    y: 326.44,
    width: 51.62,
    height: 2.95,
    transform: "translate(1478.07 320.56) rotate(158.87)",
    fill: "#6c63ff"
  }))), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 636.4,
    y: 170.42,
    width: 92.18,
    height: 149.99,
    transform: "translate(215.57 853.5) rotate(-82.24)",
    fill: "url(#a2efda15-530d-45aa-b3cd-49d05531735a)"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 638.89,
    y: 172.09,
    width: 86.03,
    height: 144.91,
    transform: "matrix(0.14, -0.99, 0.99, 0.14, 215.93, 852.16)",
    fill: "#fff"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("rect", {
    x: 620.25,
    y: 200.66,
    width: 18.44,
    height: 13.64,
    transform: "translate(1093.57 463.1) rotate(-172.24)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 630.78,
    y: 241.72,
    width: 70.79,
    height: 4.42,
    transform: "translate(1161.73 540.62) rotate(-172.24)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 648.47,
    y: 253.98,
    width: 51.62,
    height: 2.95,
    transform: "translate(1176.31 564.66) rotate(-172.24)",
    fill: "#6c63ff"
  }))), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 400.85,
    y: 321.65,
    width: 92.18,
    height: 149.99,
    transform: "translate(-138.01 750.91) rotate(-82.24)",
    fill: "url(#094cca5d-27c3-47fb-8920-3b7298d459bd)"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 403.34,
    y: 323.33,
    width: 86.03,
    height: 144.91,
    transform: "translate(-137.65 749.58) rotate(-82.24)",
    fill: "#fff"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("rect", {
    x: 384.7,
    y: 351.9,
    width: 18.44,
    height: 13.64,
    transform: "translate(604.2 732.36) rotate(-172.24)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 395.23,
    y: 392.96,
    width: 70.79,
    height: 4.42,
    transform: "matrix(-0.99, -0.14, 0.14, -0.99, 672.36, 809.89)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 412.92,
    y: 405.22,
    width: 51.62,
    height: 2.95,
    transform: "translate(686.93 833.92) rotate(-172.24)",
    fill: "#6c63ff"
  }))), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 370.07,
    y: 223.95,
    width: 92.18,
    height: 149.99,
    transform: "translate(-67.82 635.91) rotate(-82.24)",
    fill: "url(#140a85c5-dcaa-41a5-bbcf-36a604c1c882)"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 372.56,
    y: 225.63,
    width: 86.03,
    height: 144.91,
    transform: "translate(-67.47 634.57) rotate(-82.24)",
    fill: "#fff"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("rect", {
    x: 353.91,
    y: 254.2,
    width: 18.44,
    height: 13.64,
    transform: "translate(556.12 533.7) rotate(-172.24)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 364.44,
    y: 295.25,
    width: 70.79,
    height: 4.42,
    transform: "translate(624.27 611.22) rotate(-172.24)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 382.13,
    y: 307.52,
    width: 51.62,
    height: 2.95,
    transform: "translate(638.85 635.26) rotate(-172.24)",
    fill: "#6c63ff"
  }))), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 478.16,
    y: 289.78,
    width: 149.99,
    height: 92.18,
    transform: "translate(-204.47 137.08) rotate(-16.6)",
    fill: "url(#e09d3dbe-6def-45ce-bc92-f1e4ec85f07d)"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 479.81,
    y: 292.31,
    width: 144.91,
    height: 86.03,
    transform: "translate(-204.35 136.8) rotate(-16.6)",
    fill: "#f4f6f7"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("rect", {
    x: 479.99,
    y: 316.38,
    width: 18.44,
    height: 13.64,
    transform: "translate(918.81 458.12) rotate(163.4)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 502.28,
    y: 339.04,
    width: 70.79,
    height: 4.42,
    transform: "translate(1018.9 479.63) rotate(163.4)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 524.01,
    y: 346.93,
    width: 51.62,
    height: 2.95,
    transform: "translate(1044.72 490.17) rotate(163.4)",
    fill: "#6c63ff"
  }))), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 262.69,
    y: 317.89,
    width: 149.99,
    height: 92.18,
    transform: "translate(-221.49 76.68) rotate(-16.6)",
    fill: "url(#bcc8fcf0-1b1e-40bd-bc5b-91eb65ebeff2)"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 264.33,
    y: 320.41,
    width: 144.91,
    height: 86.03,
    transform: "translate(-221.37 76.4) rotate(-16.6)",
    fill: "#f4f6f7"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("rect", {
    x: 264.51,
    y: 344.48,
    width: 18.44,
    height: 13.64,
    transform: "translate(504.87 574.74) rotate(163.4)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 286.81,
    y: 367.15,
    width: 70.79,
    height: 4.42,
    transform: "translate(604.97 596.24) rotate(163.4)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 308.53,
    y: 375.04,
    width: 51.62,
    height: 2.95,
    transform: "matrix(-0.96, 0.29, -0.29, -0.96, 630.78, 606.78)",
    fill: "#6c63ff"
  }))), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 852.9,
    y: 58.94,
    width: 149.99,
    height: 92.18,
    transform: "translate(-107.02 306.61) rotate(-21.13)",
    fill: "url(#7026b8b1-cea2-4061-af6f-029e76fb3e92)"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 854.51,
    y: 61.54,
    width: 144.91,
    height: 86.03,
    transform: "translate(-106.91 306.24) rotate(-21.13)",
    fill: "#fff"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("rect", {
    x: 853.93,
    y: 90.63,
    width: 18.44,
    height: 13.64,
    transform: "translate(1571.81 -157.86) rotate(158.87)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 877.5,
    y: 109.41,
    width: 70.79,
    height: 4.42,
    transform: "translate(1673.08 -148.41) rotate(158.87)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 899.75,
    y: 116.32,
    width: 51.62,
    height: 2.95,
    transform: "translate(1699.78 -141.04) rotate(158.87)",
    fill: "#6c63ff"
  }))), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 567.89,
    y: 145.23,
    width: 104.38,
    height: 64.15,
    transform: "translate(-153.78 200.49) rotate(-21.13)",
    fill: "url(#5f629113-c274-4419-b6ca-105eac5d4e52)"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 569.01,
    y: 147.03,
    width: 100.84,
    height: 59.87,
    transform: "translate(-153.7 200.23) rotate(-21.13)",
    fill: "#fff"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("rect", {
    x: 568.6,
    y: 167.28,
    width: 12.83,
    height: 9.49,
    transform: "translate(1041.82 90.16) rotate(158.87)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 585,
    y: 180.35,
    width: 49.26,
    height: 3.08,
    transform: "translate(1112.29 96.74) rotate(158.87)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 600.49,
    y: 185.16,
    width: 35.92,
    height: 2.05,
    transform: "translate(1130.87 101.86) rotate(158.87)",
    fill: "#6c63ff"
  }))), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 139.61,
    y: 245.6,
    width: 104.38,
    height: 64.15,
    transform: "translate(-218.77 52.83) rotate(-21.13)",
    fill: "url(#c2ef43ed-fda2-43ff-bd84-ecc107fb70b7)"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 140.73,
    y: 247.41,
    width: 100.84,
    height: 59.87,
    transform: "translate(-218.7 52.57) rotate(-21.13)",
    fill: "#fff"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("rect", {
    x: 140.32,
    y: 267.65,
    width: 12.83,
    height: 9.49,
    transform: "translate(250.26 438.58) rotate(158.87)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 156.73,
    y: 280.72,
    width: 49.26,
    height: 3.08,
    transform: "translate(320.73 445.15) rotate(158.87)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 172.21,
    y: 285.53,
    width: 35.92,
    height: 2.05,
    transform: "translate(339.31 450.28) rotate(158.87)",
    fill: "#6c63ff"
  }))), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 794.07,
    y: 217.5,
    width: 104.38,
    height: 64.15,
    transform: "translate(-164.62 286.9) rotate(-21.13)",
    fill: "url(#127fb363-6911-40f5-b8ae-4e9fbcd2cde8)"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 795.19,
    y: 219.31,
    width: 100.84,
    height: 59.87,
    transform: "translate(-164.54 286.64) rotate(-21.13)",
    fill: "#f4f6f7"
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("rect", {
    x: 794.78,
    y: 239.55,
    width: 12.83,
    height: 9.49,
    transform: "translate(1505.03 148.29) rotate(158.87)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 811.19,
    y: 252.62,
    width: 49.26,
    height: 3.08,
    transform: "translate(1575.5 154.87) rotate(158.87)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 826.67,
    y: 257.43,
    width: 35.92,
    height: 2.05,
    transform: "translate(1594.08 160) rotate(158.87)",
    fill: "#6c63ff"
  }))), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 620.08,
    y: 71.62,
    width: 104.38,
    height: 64.15,
    transform: "translate(-123.73 214.36) rotate(-21.13)",
    fill: "url(#30b9b037-13cf-442c-b7db-08ecd3a25147)"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 621.2,
    y: 73.42,
    width: 100.84,
    height: 59.87,
    transform: "translate(-123.65 214.1) rotate(-21.13)",
    fill: "#f4f6f7"
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("rect", {
    x: 620.8,
    y: 93.67,
    width: 12.83,
    height: 9.49,
    transform: "translate(1116.16 -70.93) rotate(158.87)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 637.2,
    y: 106.74,
    width: 49.26,
    height: 3.08,
    transform: "translate(1186.63 -64.35) rotate(158.87)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 652.68,
    y: 111.55,
    width: 35.92,
    height: 2.05,
    transform: "translate(1205.21 -59.22) rotate(158.87)",
    fill: "#6c63ff"
  }))), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 956.01,
    y: 89.02,
    width: 104.38,
    height: 64.15,
    transform: "translate(-107.41 336.64) rotate(-21.13)",
    fill: "url(#b48a5982-ebae-46b6-b7c0-ced25ac90cb4)"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 957.13,
    y: 90.82,
    width: 100.84,
    height: 59.87,
    transform: "translate(-107.33 336.39) rotate(-21.13)",
    fill: "#f4f6f7"
  })), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("rect", {
    x: 956.72,
    y: 111.07,
    width: 12.83,
    height: 9.49,
    transform: "translate(1771.7 -158.42) rotate(158.87)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 973.13,
    y: 124.14,
    width: 49.26,
    height: 3.08,
    transform: "translate(1842.17 -151.84) rotate(158.87)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 988.61,
    y: 128.94,
    width: 35.92,
    height: 2.05,
    transform: "translate(1860.75 -146.71) rotate(158.87)",
    fill: "#6c63ff"
  }))), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 150.32,
    y: 117.12,
    width: 104.38,
    height: 64.15,
    transform: "translate(-171.73 48.05) rotate(-21.13)",
    fill: "url(#3f302154-f399-4639-adea-16a823494a16)"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 151.44,
    y: 118.93,
    width: 100.84,
    height: 59.87,
    transform: "translate(-171.65 47.79) rotate(-21.13)",
    fill: "#f4f6f7"
  })), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("rect", {
    x: 151.03,
    y: 139.17,
    width: 12.83,
    height: 9.49,
    transform: "translate(224.63 186.39) rotate(158.87)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 167.43,
    y: 152.24,
    width: 49.26,
    height: 3.08,
    transform: "translate(295.1 192.97) rotate(158.87)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 182.92,
    y: 157.05,
    width: 35.92,
    height: 2.05,
    transform: "translate(313.68 198.1) rotate(158.87)",
    fill: "#6c63ff"
  }))), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 436.99,
    y: 169.08,
    width: 92.18,
    height: 149.99,
    transform: "translate(44.42 654.75) rotate(-82.24)",
    fill: "url(#3ada4877-fd8b-49b1-a88c-9dc9f5ba336c)"
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 439.47,
    y: 170.75,
    width: 86.03,
    height: 144.91,
    transform: "translate(44.78 653.42) rotate(-82.24)",
    fill: "#fff"
  })), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("rect", {
    x: 420.83,
    y: 199.32,
    width: 18.44,
    height: 13.64,
    transform: "translate(696.75 433.49) rotate(-172.24)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 431.36,
    y: 240.38,
    width: 70.79,
    height: 4.42,
    transform: "translate(764.91 511.02) rotate(-172.24)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 449.05,
    y: 252.64,
    width: 51.62,
    height: 2.95,
    transform: "translate(779.49 535.06) rotate(-172.24)",
    fill: "#6c63ff"
  }))), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M551.12,449.54a64.35,64.35,0,0,0-19.31-39.88c-13.14-12.75-36.37-29.66-75-42.19-70.55-22.91-97.12-43.06-128.27-98l-27.49-67.8v31.15l-17.41-66s-7.79,70.09,16,126c0,0-11.91,10.08,0,27.49,0,0-28.4-4.58-4.58,42.15l20.16,29.32s-20.16,9.16,8.25,41.23L340,448.56s-39.4,12.83,12.83,58.64c0,0,66.88,54.06,120.94,38.48C521.12,532,555.8,498,551.12,449.54Z",
    transform: "translate(-131.56 -35)",
    fill: "url(#d51fede2-78e8-4620-b3d8-713c35bf1f26)"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M547.86,447.31A62.79,62.79,0,0,0,529,408.4c-12.82-12.44-35.49-28.94-73.13-41.17-68.84-22.35-94.76-42-125.16-95.66l-26.82-66.15v30.4l-17-64.37s-7.6,68.39,15.64,122.92c0,0-11.62,9.83,0,26.82,0,0-27.71-4.47-4.47,41.12l19.67,28.61s-19.67,8.94,8,40.23l16.09,15.2s-38.44,12.52,12.52,57.21c0,0,65.26,52.74,118,37.55C518.59,527.81,552.43,494.64,547.86,447.31Z",
    transform: "translate(-131.56 -35)",
    fill: "#dfe5ee"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M345.48,343.54,293.63,215.7s5.36,60.79,18.77,86.72c0,0-17-11.62,7.15,37.55,0,0-51.85-39.33,0,40.23l20.56,19.67s-36.53-15.65-17.65,16a89.45,89.45,0,0,0,28.9,29.53l15.57,9.91s-51.85-16.09-17.88,31.29c0,0,36.65,34.87,59.9,37.55,0,0-59.9-38.44-45.59-52.74S417,482.11,417,482.11s-69.73-48.27-66.15-60.79,37.55,16.09,37.55,16.09-71.52-68.84-67.94-79.56,5.36-11.62,28.61,11.62c0,0-30.4-42.91-25.93-49.17S345.48,343.54,345.48,343.54Z",
    transform: "translate(-131.56 -35)",
    fill: "#ebf1f6"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M522.49,499.09s50-59-47.38-93a493,493,0,0,1-71.77-31.22A176.36,176.36,0,0,1,317.17,268c-2.41-8.49-3.52-14.89-2.09-16.57,0,0,29.5,78.67,91.19,106.38l81.35,30.4S580.6,423.11,522.49,499.09Z",
    transform: "translate(-131.56 -35)",
    fill: "#ebf1f6"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M577,449.54a64.35,64.35,0,0,1,19.31-39.88c13.14-12.75,36.37-29.66,75-42.19,70.55-22.91,97.12-43.06,128.27-98L827,201.63v31.15l17.41-66s7.79,70.09-16,126c0,0,11.91,10.08,0,27.49,0,0,28.4-4.58,4.58,42.15l-20.16,29.32S833,400.91,804.57,433l-16.49,15.58s39.4,12.83-12.83,58.64c0,0-66.88,54.06-120.94,38.48C607,532,572.31,498,577,449.54Z",
    transform: "translate(-131.56 -35)",
    fill: "url(#1006e8ff-8602-4633-86d3-6de2a9ceacc2)"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M580.25,447.31a62.79,62.79,0,0,1,18.84-38.91c12.82-12.44,35.49-28.94,73.13-41.17,68.84-22.35,94.76-42,125.16-95.66l26.82-66.15v30.4l17-64.37s7.6,68.39-15.64,122.92c0,0,11.62,9.83,0,26.82,0,0,27.71-4.47,4.47,41.12l-19.67,28.61s19.67,8.94-8,40.23l-16.09,15.2s38.44,12.52-12.52,57.21c0,0-65.26,52.74-118,37.55C609.52,527.81,575.68,494.64,580.25,447.31Z",
    transform: "translate(-131.56 -35)",
    fill: "#dfe5ee"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M782.64,343.54,834.49,215.7s-5.36,60.79-18.77,86.72c0,0,17-11.62-7.15,37.55,0,0,51.85-39.33,0,40.23L788,399.86s36.53-15.65,17.65,16a89.45,89.45,0,0,1-28.9,29.53l-15.57,9.91S813,439.2,779.06,486.58c0,0-36.65,34.87-59.9,37.55,0,0,59.9-38.44,45.59-52.74s-53.64,10.73-53.64,10.73,69.73-48.27,66.15-60.79-37.55,16.09-37.55,16.09,71.52-68.84,67.94-79.56-5.36-11.62-28.61,11.62c0,0,30.4-42.91,25.93-49.17S782.64,343.54,782.64,343.54Z",
    transform: "translate(-131.56 -35)",
    fill: "#ebf1f6"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M605.63,499.09s-50-59,47.38-93a493,493,0,0,0,71.77-31.22A176.36,176.36,0,0,0,810.94,268c2.41-8.49,3.52-14.89,2.09-16.57,0,0-29.5,78.67-91.19,106.38l-81.35,30.4S547.52,423.11,605.63,499.09Z",
    transform: "translate(-131.56 -35)",
    fill: "#ebf1f6"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M539.78,551.26a.92.92,0,0,0,1.09.14A3.72,3.72,0,0,1,539.78,551.26Z",
    transform: "translate(-131.56 -35)",
    fill: "url(#fbbe768f-3ed7-4776-9e16-963371c4c4e8)"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M661.88,352.81c-2.15-.63-5.23-1.65-8.93-2.93a46.87,46.87,0,0,0,8.28-16.68l-.32.12c.11-.37.22-.74.32-1.11-7.1,2.88-15-2-20-8.28s-8.4-14.06-13.88-19.84a63.46,63.46,0,0,0-7.36-6.33c-1.62-1.25-3.36-2.55-5.33-2.61-3.2-.09-5.7,3-8.79,4a12,12,0,0,1-6.13-.23c-7.94-1.82-15.61-5.19-23.68-6.07a27.75,27.75,0,0,0-12.85,1.45c-4.07,1.55-5.93,4.62-9.23,7.09-3.55,2.65-10.62,2.59-14.8,3.06a106,106,0,0,1-15.29.63,35.79,35.79,0,0,0-8.8.33c-6.07,1.33-11,6.16-15.51,10.8a8,8,0,0,0-2.56,4,5.07,5.07,0,0,0,0,1.33,8.63,8.63,0,0,0,.61,3.53,46.66,46.66,0,0,0,5.89,11.71c1.86,2.66,4,5.17,5.08,8.32a16.14,16.14,0,0,1,.78,4.79,34.85,34.85,0,0,1-.54,5.15,64.75,64.75,0,0,1-3.94,13.71c-1,2.34-2.08,4.68-2.3,7.24a11.45,11.45,0,0,0,0,1.53c-.3,7.91,7.68,13.6,9.22,21.46a12.82,12.82,0,0,1,.22,2c-.17,4.9-3,9.7-7.08,11.59.36.14.73.26,1.1.39a10,10,0,0,1-1.1.6c.75.29,1.52.53,2.3.75A53.43,53.43,0,0,0,495.6,428.6C481.82,454.36,388,504.9,388,504.9s.53.29,1.39.79l-1.13.73c-8.12,5.4-27.19,21.16-10,41.08,0,0,13.46-21.23,22.88-30.28.42-.4.83-.78,1.24-1.13a2.75,2.75,0,0,1,.36,2.18l61.72-34.68s21.93-15.36,28.05-18.83c2.11-1.19,7.48-4.5,13.91-6l-.72.3a28.17,28.17,0,0,1,7.08-1c10.93.17,22.76,8.17,26.66,39.86,5.23,42.44,2.8,50.09,1.13,51.14A3.08,3.08,0,0,1,540,549a1,1,0,0,0,.16.12,3.21,3.21,0,0,1-.67-.12,1,1,0,0,0,.91.22.85.85,0,0,0,.69-.08h0a7.09,7.09,0,0,0,.82,0q0,.58-.08,1.19c-.08,0-.49.22-.05.25h0c-.13,2.39-.12,5,0,7.72-5.43.3-10.85.62-15.6.91l.42-2.24.19-1c4.17-.33,8.12-1.56,8.59-4.94,1-7.43-9.18-11.39-17.85-11.89s-60.7,3-60.7,3-7.8,10.1,16.94,13.23q1.1.57,2.29,1.25c9.69,5.53,22.84,15.69,29.14,20.71l.88.7-2.83,2.25c15.3,3.47,30.09,61.93,38.26,88.68s26,25.76,40.81,21.8c13.86-3.72,15.63-44,15.8-49l0-.52,24.65,30.39,1.87,2.31q1.08.56,2.13,1.06c18.67,8.88,39.29-8.15,33.42-27.52-5.93-19.57-15.13-48.49-21.27-60.73-5.14-10.24-11.78-27.25-15.81-37.91a12.8,12.8,0,0,0,1.52-.73s-.09-.48-.25-1.35l.25-.14s-5.93-30.82-6.26-52.71q0-.58,0-1.15c0-.24,0-.47,0-.71,4.46-1,7.28-1.41,7.28-1.41l.08-1-.52.11,2.48-28.39s9.1-19.37,2.13-27.44a16.94,16.94,0,0,1-4.09-8.38c-1.16-7.42,0-19.79,16.24-30.07,25-15.85,34.69-28.73,34.69-28.73S677.18,357.27,661.88,352.81ZM612.25,372.5V359.38c4.64-.23,9.37.31,14,0a35.5,35.5,0,0,0,6.77-1.13l1.12.78A123.38,123.38,0,0,1,612.25,372.5ZM541.38,578.13c1.84,1.27,3.68,2.59,5.49,3.91,1.12,6.47,2.12,11,2.19,11.36A89.69,89.69,0,0,0,541.38,578.13Z",
    transform: "translate(-131.56 -35)",
    fill: "url(#34e30e13-4b6f-4fce-83d2-4daee813bb86)"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M581,567.35l-1.08,5.86-.82,4.48-1.51,8.2-14.64,10.25s-1.32-1.12-3.5-2.91c-6-4.94-18.61-15-27.87-20.4a31.21,31.21,0,0,0-7.66-3.53Z",
    transform: "translate(-131.56 -35)",
    fill: "#ffbdc6"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M581,567.35l-1.08,5.86a45.49,45.49,0,0,1-9.66-.49l-34.16.49c-1.62-.1-3.13-.22-4.54-.37a31.21,31.21,0,0,0-7.66-3.53Z",
    transform: "translate(-131.56 -35)",
    opacity: 0.1
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M570.25,571.74s17.08,2.93,18.05-4.39-8.78-11.22-17.08-11.71-58.07,2.93-58.07,2.93-8.78,11.71,22.93,13.66Z",
    transform: "translate(-131.56 -35)",
    fill: "#7679b4"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M581,567.35l-1.08,5.86-.82,4.48-1.51,8.2-14.64,10.25s-1.32-1.12-3.5-2.91c-6-4.94-18.61-15-27.87-20.4a31.21,31.21,0,0,0-7.66-3.53Z",
    transform: "translate(-131.56 -35)",
    opacity: 0.1
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M581,567.35l-1.08,5.86a45.49,45.49,0,0,1-9.66-.49l-34.16.49c-1.62-.1-3.13-.22-4.54-.37a31.21,31.21,0,0,0-7.66-3.53Z",
    transform: "translate(-131.56 -35)",
    opacity: 0.1
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M570.25,571.74s17.08,2.93,18.05-4.39-8.78-11.22-17.08-11.71-58.07,2.93-58.07,2.93-8.78,11.71,22.93,13.66Z",
    transform: "translate(-131.56 -35)",
    opacity: 0.1
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 386.73,
    y: 296.18,
    width: 89.3,
    height: 105.89,
    fill: "#a66477"
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 386.73,
    y: 296.18,
    width: 89.3,
    height: 105.89,
    opacity: 0.1
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M413.62,512.46c-1.47.37-3.35,1.79-5.44,3.85-9,8.91-21.89,29.82-21.89,29.82C369.81,526.5,388,511,395.82,505.66c1.89-1.29,3.16-2,3.16-2Z",
    transform: "translate(-131.56 -35)",
    fill: "#ffbdc6"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M580,364.61s4.39,30.74,19.52,38.06-19.52,21-19.52,21l-47.33-17.57s26.84-8.78,21.47-34.65Z",
    transform: "translate(-131.56 -35)",
    fill: "#ffbdc6"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M529.26,549.54l-1.08,5.86-.82,4.48-1.51,8.2-14.64,10.25s-1.32-1.12-3.5-2.91c-6-4.94-18.61-15-27.87-20.4a31.21,31.21,0,0,0-7.66-3.53Z",
    transform: "translate(-131.56 -35)",
    fill: "#ffbdc6"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M529.26,549.54l-1.08,5.86a45.49,45.49,0,0,1-9.66-.49l-34.16.49c-1.62-.1-3.13-.22-4.54-.37a31.21,31.21,0,0,0-7.66-3.53Z",
    transform: "translate(-131.56 -35)",
    opacity: 0.1
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M518.53,553.93s17.08,2.93,18.05-4.39-8.78-11.22-17.08-11.71-58.07,2.93-58.07,2.93-8.78,11.71,22.93,13.66Z",
    transform: "translate(-131.56 -35)",
    fill: "#7679b4"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M527.36,559.89l-1.51,8.2-14.64,10.25s-1.32-1.12-3.5-2.91l19.36-15.88Z",
    transform: "translate(-131.56 -35)",
    opacity: 0.1
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M624,671.6q-1-.49-2-1l-1.79-2.27L596.6,638.35v.51c-.16,5-1.85,44.62-15.11,48.28-14.15,3.9-31.23,4.88-39-21.47s-22-83.93-36.6-87.34l21.71-17.81s14.38,16.82,20.25,32.92c-.22-1-10.15-47.41-1.95-55.61H617.1s11,31.32,18.54,46.84c5.87,12.05,14.68,40.54,20.35,59.82C661.6,663.57,641.88,680.35,624,671.6Z",
    transform: "translate(-131.56 -35)",
    fill: "#7679b4"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M622,546.61c-11,6.51-59.29,3.86-75,2.8l-4.27-.31c-.46,0,.07-.26.07-.26l.44-4.43,11.71-29.77,62.7-36.35c-1.27,3.83-1.7,9.69-1.6,16.4C616.3,516.26,622,546.61,622,546.61Z",
    transform: "translate(-131.56 -35)",
    opacity: 0.1
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M622,545.15c-11,6.51-59.29,3.86-75,2.8l-4.27-.31-.71-.05.78-.2,3.85-1,8.3-33.18,62.7-36.35c-1.27,3.83-1.7,9.69-1.6,16.4C616.3,514.8,622,545.15,622,545.15Z",
    transform: "translate(-131.56 -35)",
    fill: "#f2f1f2"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M616,493.24c-12.75,2.94-40.81,11.57-51.59,32.4-7.19,13.88-13.24,19.83-17.46,22.32l-4.27-.31.07-.26,3.85-1,8.3-33.18,62.7-36.35C616.31,480.66,615.89,486.52,616,493.24Z",
    transform: "translate(-131.56 -35)",
    opacity: 0.1
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M399,503.67l14.64,8.78c-1.47.37-3.35,1.79-5.44,3.85-1.22-3.56-8.89-8.53-12.36-10.64C397.71,504.37,399,503.67,399,503.67Z",
    transform: "translate(-131.56 -35)",
    opacity: 0.1
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M540.05,548.22a.87.87,0,0,1-1-.14A3.52,3.52,0,0,0,540.05,548.22Z",
    transform: "translate(-131.56 -35)",
    opacity: 0.1
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M573.18,400.72s-13.17,1.46-22.45-8.3c0,0-39,11.22-52.21,36.6s-103,75.15-103,75.15,15.61,8.78,14.15,13.17l59-34.16s21-15.13,26.84-18.54,38.06-24.4,44.89,32.69,0,50.26,0,50.26,9.76,3.42,23.91-23.91S622.46,490,622.46,490l2.44-28.79s8.71-19.08,2-27a16.89,16.89,0,0,1-3.91-8.26c-1.11-7.31,0-19.49,15.53-29.61,23.91-15.61,33.18-28.3,33.18-28.3s.49-9.27-14.15-13.66-74.17-28.3-74.17-28.3l-2,8.3,46.84,33.18s-23.42,19-42,18.54C586.36,386.08,589.77,400.23,573.18,400.72Z",
    transform: "translate(-131.56 -35)",
    fill: "#565388"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M582.22,378a95.9,95.9,0,0,1-2.7-11.92l-25.86,6.83a28.51,28.51,0,0,1-.59,14.92A27.81,27.81,0,0,0,582.22,378Z",
    transform: "translate(-131.56 -35)",
    opacity: 0.1
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 429.18,
    cy: 324.48,
    r: 27.81,
    fill: "#ffbdc6"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M575.53,296.24c7.72.87,15.06,4.19,22.65,6a11.19,11.19,0,0,0,5.86.22c3-.91,5.35-4,8.41-3.91,1.89.06,3.55,1.34,5.1,2.57a61.24,61.24,0,0,1,7,6.24c5.24,5.69,8.49,13.35,13.28,19.54s12.32,11,19.11,8.16c-4.62,18-19.75,31.71-36.12,32.83-6.53.45-13.22-.92-19.54,1a17.11,17.11,0,0,1-4.93,1.2c-3.64,0-6.57-3.34-8.84-6.59-5.32-7.64-9.53-16.31-15.52-23.28-2-2.3-4.31-4.49-7.11-4.91s-5.37.91-7.86,2.2c-4.11,2.13-8.32,4.33-11.5,8s-5.19,9.1-3.88,14c.71,2.66,2.33,5.06,2.36,7.84.05,4.43-3.86,7.68-4.64,12a46.24,46.24,0,0,0-.19,5.46c-.34,5.92-4.21,10.77-8.25,14.49-1.57,1.45-3.31,3-3.77,5.23-.31,1.53,0,3.14-.2,4.69-.59,3.84-4.42,5.79-7.81,6.29a22.64,22.64,0,0,1-11.72-1.39c4.74-2.25,7.65-8.62,6.56-14.34-1.51-7.92-9.47-13.6-8.8-21.67a25.07,25.07,0,0,1,2.2-7.13,65.23,65.23,0,0,0,3.77-13.51c.59-3.57.88-7.36-.23-10.77-1-3.1-3.09-5.57-4.86-8.19A46.51,46.51,0,0,1,500.46,327a8.08,8.08,0,0,1-.54-3.82,7.9,7.9,0,0,1,2.45-3.95c4.36-4.57,9-9.33,14.83-10.63a33.26,33.26,0,0,1,8.42-.32,98.53,98.53,0,0,0,14.63-.62c4-.47,10.76-.4,14.16-3,3.16-2.43,4.93-5.46,8.83-7A25.84,25.84,0,0,1,575.53,296.24Z",
    transform: "translate(-131.56 -35)",
    opacity: 0.1
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M591,583.46s16.1,31.72,11.22,41.48",
    transform: "translate(-131.56 -35)",
    opacity: 0.1
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M620.19,668.28,596.6,638.35v.51s-1.36-9.68,3.13-6.43c9.84,7.12,25.58,18.79,25.92,20.8S622.46,663.31,620.19,668.28Z",
    transform: "translate(-131.56 -35)",
    opacity: 0.1
  })), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M586.84,386.08s2,8.24-4.45,12.36c9.9-1.7,10.34-9.4,10-12.75A31.23,31.23,0,0,1,586.84,386.08Z",
    transform: "translate(-131.56 -35)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.42,502.21s89.78-49.77,103-75.15c9.45-18.21,32.23-29.13,44.34-33.85-8.83,3-38.54,14.3-49.7,35.8-13.17,25.37-103,75.15-103,75.15Z",
    transform: "translate(-131.56 -35)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M604.29,382.2c15.28-4.75,29.88-16.62,29.88-16.62L587.33,332.4l1.07-4.55-4.49-1.79-2,8.3,46.84,33.18A113,113,0,0,1,604.29,382.2Z",
    transform: "translate(-131.56 -35)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M604.59,494.65A116.07,116.07,0,0,1,623,490l.08-.94A124.31,124.31,0,0,0,604.59,494.65Z",
    transform: "translate(-131.56 -35)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M547.81,545.77h-.43a.88.88,0,0,1-1-.14,3.64,3.64,0,0,0,1,.14c1.6-.93,4-8.22-1-50.4-5.39-45-26.55-41.49-38.13-36.31,11.84-3.26,28.13-.44,32.76,38.26,5,42.18,2.64,49.46,1,50.4A10.82,10.82,0,0,0,547.81,545.77Z",
    transform: "translate(-131.56 -35)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M542,547.73a3.64,3.64,0,0,1-1-.14A.88.88,0,0,0,542,547.73Z",
    transform: "translate(-131.56 -35)"
  }))), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M575.53,295.26c7.72.87,15.06,4.19,22.65,6a11.19,11.19,0,0,0,5.86.22c3-.91,5.35-4,8.41-3.91,1.89.06,3.55,1.34,5.1,2.57a61.24,61.24,0,0,1,7,6.24c5.24,5.69,8.49,13.35,13.28,19.54s12.32,11,19.11,8.16c-4.62,18-19.75,31.71-36.12,32.83-6.53.45-13.22-.92-19.54,1a17.11,17.11,0,0,1-4.93,1.2c-3.64,0-6.57-3.34-8.84-6.59-5.32-7.64-9.53-16.31-15.52-23.28-2-2.3-4.31-4.49-7.11-4.91s-5.37.91-7.86,2.2c-4.11,2.13-8.32,4.33-11.5,8s-5.19,9.1-3.88,14c.71,2.66,2.33,5.06,2.36,7.84.05,4.43-3.86,7.68-4.64,12a46.24,46.24,0,0,0-.19,5.46c-.34,5.92-4.21,10.77-8.25,14.49-1.57,1.45-3.31,3-3.77,5.23-.31,1.53,0,3.14-.2,4.69-.59,3.84-4.42,5.79-7.81,6.29a22.64,22.64,0,0,1-11.72-1.39c4.74-2.25,7.65-8.62,6.56-14.34-1.51-7.92-9.47-13.6-8.8-21.67a25.07,25.07,0,0,1,2.2-7.13,65.23,65.23,0,0,0,3.77-13.51c.59-3.57.88-7.36-.23-10.77-1-3.1-3.09-5.57-4.86-8.19A46.51,46.51,0,0,1,500.46,326a8.08,8.08,0,0,1-.54-3.82,7.9,7.9,0,0,1,2.45-3.95c4.36-4.57,9-9.33,14.83-10.63a33.26,33.26,0,0,1,8.42-.32,98.53,98.53,0,0,0,14.63-.62c4-.47,10.76-.4,14.16-3,3.16-2.43,4.93-5.46,8.83-7A25.84,25.84,0,0,1,575.53,295.26Z",
    transform: "translate(-131.56 -35)",
    fill: "#a66477"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHermesApi);
export default __webpack_public_path__ + "static/media/Hermes_API.408903c3.svg";
export { ForwardRef as ReactComponent };